module.exports = __webpack_public_path__ + "fonts/SwatchCTWeb-Bold.0d95e036.ttf";